import { Api, Auth } from '~/services';

export const getAllInterests = () => {
    return Api.get( '/wp/interests', {}, ( data, error ) => {
        if ( ! data || !data.length || error ) return;

        return data;
    })
}

export const getInterestsFeed = (params, slug) => {
    return Api.get( '/wp/feed/interest/' + slug, params, ( data, error ) => {
        if ( ! data || error ) {
            return;
        }

        return data;
    })
}


// WEBPACK FOOTER //
// ./src/js/api/interests.js